import * as core from '../../../../../../../core'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'outcomes',
    appAlias: summit.RESOURCE.payload.alias,
    description:
      "View your organization's strategic goals in a visual sunburst chart",
    display: {
      isMain: false,
      position: 1,
    },
    name: 'Outcomes (Sunburst)',
    page: { alias: 'summit:outcomes-sunburst' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
